import { chatdate } from '@/utilities/dateUtils';
import { i18n, TFunction } from 'i18next';
import { enTranslations, Streami18n } from 'stream-chat-react';

// these keys have technical value, that does not need override
const excludedKeys = new Set<string>([
  'timestamp/DateSeparator',
  'timestamp/MessageTimestamp',
  'timestamp/PollVote',
  'timestamp/PollVoteTooltip',
  'timestamp/ReminderNotification',
  'timestamp/SystemMessage',
  'duration/Message reminder',
  'duration/Remind Me',
]);

export default function itrackStreamI18n(t: TFunction, i18n: i18n): Streami18n {
  const overrides: Record<string, string> = {};
  const langKeys = Object.keys(enTranslations);
  langKeys.forEach((key) => {
    if (!excludedKeys.has(key)) {
      overrides[key] = t('streamChat.' + key);
    }
  });

  const streami18n = new Streami18n({
    formatters: {
      timestampFormatter: () => (val: string | Date) => {
        const timeMicros = new Date(val).getTime() * 1000;
        return chatdate(timeMicros, i18n.language, t);
      },
    },
  });

  // the second parameter of registerTranslation need to be type of enTranslations
  const enOverrides = {
    ...enTranslations,
    ...overrides,
  };
  const fakeLocale = {};

  streami18n.registerTranslation(i18n.language, enOverrides, fakeLocale);
  // FIXME ez gaz, await kellene
  void streami18n.setLanguage(i18n.language);
  return streami18n;
}
